import React, { Component } from 'react';
import Header from './Layout/Header';
import ReactApexChart from 'react-apexcharts';
import { PieChart } from 'react-minimal-pie-chart';
import { dataUser, dataLocation, logoutHandler } from './Helpers/util';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Navigate } from 'react-router-dom';
import MarketingPanel from '../Component/MarketingPanel';
import { getServiceAccess } from '../Redux/action/userActions';
import Sidebar from "../Component/Layout/Sidebar";
import CustomHeader from "../Component/Layout/Header";
import { Layout } from "antd";
import mixpanel from 'mixpanel-browser';
import SwSelect from './Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from './Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from "dayjs";
import SwButton from './Common/SwButtons/SwButtons';
import SwLoader from './Common/SwLoader/SwLoader';


const apiURL = require('./../constant');
const URL_API = apiURL.PROD_URL;
const labels = [
  '#0984e3',
  '#4DA191',
  '#FFA3EF',
  '#A6CCD0',
  '#a9d4a9',
  '#572898',
  '#4DA125',
  '#E59866',
  '#F1B431',
  '#B744AB',
  '#1BBFD8',
  '#D8801B',
  '#39053A',
];
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
var flexi_sum = 0;
var occuData_sum = 0;
var sbl_sum = 0;
var swd_sum = 0;
var db_booking_sum = 0;

class BookingInfoseat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flexiChartData: [],
      collapsed: true,
      occuChartData: [],
      seatChartData: [],
      locationSpoc: [],
      locationData: [],
      departChartData: [],
      shiftChartData: [],
      loaderServiceAccess: true,
      accessServiceLists: [],
      stDate: '',
      enDate: '',
      time: 'weekly',
      location_id: 'all', // 👈 default selected
      locID: 0,
      locationFilter: 0,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      seatOccuSeries: [
        {
          name: 'Seat Count',
          data: [],
        },
      ],
      seatOccuOptions: {
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          },
        },
        chart: {
          height: 220,
          width: '100%',
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'straight',
        },
        title: {
          text: '',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          // tickAmount: 20,
          categories: [
            'Week 1',
            'Week 2',
            'Week 3',
            'Week 4',
            'Week 5',
            'Week 6',
            'Week 7',
            'Week 8',
            'Week 9',
            'Week 10',
            'Week 11',
            'Week 12',
          ],
        },
      },
    };
  }

  showToastMsg = (msg, position) => {
    toast.configure();
    toast.error(msg, {

    });
  };


  getSelectedLocationIds = () => {
    const { location_id } = this.state;

    if (location_id === 'all') {
      return LocationObj; // all locations array
    }

    return [location_id]; // single selected location
  };


  flexiSeatView() {
    mixpanel.track('Reports flexi seats page view', {
      PageName: 'Flexi Seat Analytics',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      // UserId: UserObj.rec_id,
      // CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Flexi Seat Analytics',
    });
  }



  toggleCollapsed = () => {
    this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
  };

  // componentDidMount() {


  //   let authToken = JSON.parse(localStorage.getItem('headData'))

  //   const params = {
  //     params: { spoc: UserObj.rec_id, client: UserObj.company_id }, headers: {
  //       Authorization: authToken?.spintlyToken,
  //     }
  //   }
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`, params
  //     )
  //     .then(res => {
  //       if (res.data.status == "success") {
  //         this.setState({
  //           locationSpoc: res.data.data
  //         });
  //       }
  //     });
  //   this.getLocationData();
  //   this.getFlexiFixedData();
  //   this.getOccupiedVacantData();
  //   this.getSeatBookingData();
  //   this.getShiftWiseData();
  //   this.getDeptBookingData();
  //   this.getSeatOccupancyData('weekly');
  //   this.flexiSeatView();
  // }
  componentDidMount() {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    const axiosConfig = {
      params: {
        // spoc: UserObj.rec_id,
        spoc: '56793',
        client: UserObj.company_id
      },
      headers: {
        Authorization: `${authToken?.spintlyToken}`
      }
    };

    const apiRequests = [
      axios.get(`${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`, axiosConfig),
      // Add more API requests here as needed
    ];

    Promise.all(apiRequests)
      .then(responses => {
        const locationResponse = responses[0];
        if (locationResponse.data.status === "success") {
          this.setState({
            locationSpoc: locationResponse.data.data
          });
        }

        // Handle other responses here if needed
      })
      .catch(error => {
        console.error(error);
        // Handle errors here
      });

    // Call other methods
    this.getLocationData();
    this.getFlexiFixedData();
    this.getOccupiedVacantData();
    this.getSeatBookingData();
    this.getShiftWiseData();
    this.getDeptBookingData();
    this.getSeatOccupancyData('weekly');
    this.flexiSeatView();
  }

  componentWillMount() {
    this.fetchServiceAccess();
  }

  fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response, loaderServiceAccess: false });
  }

  getLocationData = async () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      let dataAry = { company_id: UserObj.company_id, Location: LocationObj };
      // get Break of Meeting data
      await axios
        .post(URL_API + 'api/v1/user/account_details', dataAry, {
          headers: {
            Authorization: authToken?.spintlyToken,
          }
        })
        .then(res => {
          let locdata = res.data.data;
          this.setState({
            locationData: locdata,
          });
        });
    } catch (err) {
      console.log(err);
    }
  };





  getFlexiFixedData = async () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      // let dataAry = { company_id: UserObj.company_id };
      let dataAry = {
        company_id: UserObj.company_id,
        stDate: this.state.stDate,
        enDate: this.state.enDate,
        location_id: this.getSelectedLocationIds()
      };

      // get Break of Meeting data
      await axios
        .post(URL_API + 'api/v1/user/flexi_count', dataAry, {
          headers: {
            Authorization: authToken?.spintlyToken,
          }
        })
        .then(res => {
          let flexidata = res.data.data;
          flexi_sum = flexidata.total;
          if (flexi_sum > 0) {
            let flexiPieChartData = [
              {
                title: 'Flexi Seat \nCount: ' + flexidata.flexi,
                value: flexidata.flexi,
                color: '#a9d4a9',
              },
              {
                title: 'Fixed Seat \nCount: ' + flexidata.fixed,
                value: flexidata.fixed,
                color: '#5CB85C',
              },
            ];
            this.setState({
              flexiChartData: flexiPieChartData,
            });
          } else {
            flexi_sum = 0;
            this.setState({
              flexiChartData: [
                { title: 'No Data', value: 1, color: '#f3f3f3' },
              ],
            });
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  getOccupiedVacantData = async () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      let dataAry = {
        company_id: UserObj.company_id,
        stDate: this.state.stDate,
        enDate: this.state.enDate,
        location_id:
          this.state.location_id === 'all'
            ? LocationObj // existing array of all locations
            : [this.state.location_id],
      };
      // get Break of Meeting data
      await axios
        .post(URL_API + 'api/v1/user/occupied_count', dataAry, {
          headers: {
            Authorization: authToken?.spintlyToken,
          }
        })
        .then(res => {
          let occudata = res.data.data;
          occuData_sum = occudata.occupied + occudata.vacant;
          if (occuData_sum > 0) {
            let occuPieChartData = [
              {
                title: 'Occupied Seat \nCount: ' + occudata.occupied,
                value: occudata.occupied,
                color: '#2871d0',
              },
              {
                title: 'Vacant Seat \nCount: ' + occudata.vacant,
                value: occudata.vacant,
                color: '#a0cbf0',
              },
            ];
            this.setState({
              occuChartData: occuPieChartData,
            });
          } else {
            occuData_sum = 0;
            this.setState({
              occuChartData: [{ title: 'No Data', value: 1, color: '#f3f3f3' }],
            });
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  getSeatOccupancyData = period => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      let dataAry = {
        company_id: UserObj.company_id,
        period: period,
        stDate: this.state.stDate,
        enDate: this.state.enDate,
        location_id: this.getSelectedLocationIds()
      };
      // get Day time graph data
      axios.post(URL_API + 'api/v1/user/seat_occupancy', dataAry, {
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      }).then(res => {
        let ocData = res.data.data;
        this.setState({
          seatOccuSeries: [
            {
              data: Object.values(ocData),
            },
          ],
          seatOccuOptions: {
            xaxis: {
              categories: Object.keys(ocData),
            },
          },
        });
      });
    } catch (err) {
      console.log(err);
    }
  };

  getSeatBookingData = () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      let dataAry = {
        company_id: UserObj.company_id,
        stDate: this.state.stDate,
        enDate: this.state.enDate,
        location_id: this.getSelectedLocationIds()
      };
      // get Day time graph data
      axios
        .post(URL_API + 'api/v1/user/loc_seat_booking', dataAry, {
          headers: {
            Authorization: authToken?.spintlyToken,
          }
        })
        .then(res => {
          let seatdata = res.data.data;
          if (seatdata.length > 0) {
            sbl_sum = 0;
            seatdata.forEach(element => {
              sbl_sum = sbl_sum + element['seat_count'];
            });

            let chartData = seatdata.map((element, index) => ({
              title:
                element['location_name'] + '\nCount: ' + element['seat_count'],
              value: element['seat_count'],
              color: labels[index],
            }));
            this.setState({
              seatChartData: chartData,
            });
          } else {
            sbl_sum = 0;
            this.setState({
              seatChartData: [{ title: 'No Data', value: 1, color: '#f3f3f3' }],
            });
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  getDeptBookingData = () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      let dataAry = {
        company_id: UserObj.company_id,
        stDate: this.state.stDate,
        enDate: this.state.enDate,
        location_id: this.getSelectedLocationIds(),
      };
      // get Day time graph data
      axios
        .post(URL_API + 'api/v1/user/dept_wise_booking', dataAry, {
          headers: {
            Authorization: authToken?.spintlyToken,
          }
        })
        .then(res => {
          let seatdata = res.data.data;
          if (seatdata.length > 0) {
            db_booking_sum = 0;
            seatdata.forEach(element => {
              db_booking_sum = db_booking_sum + element['seat_count'];
            });
            let deprtData = seatdata.map((element, index) => ({
              title: element['dept_name'] + '\nCount: ' + element['seat_count'],
              value: element['seat_count'],
              color: labels[index],
            }));
            this.setState({
              departChartData: deprtData,
            });
          } else {
            db_booking_sum = 0;
            this.setState({
              departChartData: [
                { title: 'No Data', value: 1, color: '#f3f3f3' },
              ],
            });
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  getShiftWiseData = () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      let dataAry = {
        company_id: UserObj.company_id,
        stDate: this.state.stDate,
        enDate: this.state.enDate,
        location_id: this.getSelectedLocationIds()
      }
      axios
        .post(URL_API + 'api/v1/user/shift_wise_booking', dataAry, {
          headers: {
            Authorization: authToken?.spintlyToken,
          }
        })
        .then(res => {
          let seatdata = res.data.data;
          if (seatdata.length > 0) {
            swd_sum = 0;
            seatdata.forEach(element => {
              swd_sum = swd_sum + element['users'];
            });

            let shiftData = seatdata.map((element, index) => ({
              title:
                moment(element['user_shift'].split('-')[0], 'HH:mm:ss').format(
                  'hh:mm A',
                ) +
                '-' +
                moment(element['user_shift'].split('-')[1], 'HH:mm:ss').format(
                  'hh:mm A',
                ) +
                '\nCount: ' +
                element['users'],
              value: element['users'],
              color: labels[index],
            }));
            this.setState({
              shiftChartData: shiftData,
            });
          } else {
            swd_sum = 0;
            this.setState({
              shiftChartData: [
                { title: 'No Data', value: 1, color: '#f3f3f3' },
              ],
            });
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  setFilterValue = e => {

    if (e.target.name == 'location_id') {
      this.setState({
        ...this.state,
        locationFilter: JSON.stringify([e.target.value]),
        location_id: e.target.value,
      });
    } else {
      this.setState({
        ...this.state,
        [e.target.name]: e.target.value,
      });
    }
    // if (e.target.name == 'stDate') {
    //   this.setState({
    //     [e.target.name]: e.target.value,
    //     enDate: moment(new Date()).format('YYYY-MM-DD'),
    //   });
    // } else {
    //   this.setState({
    //     [e.target.name]: e.target.value,
    //   });
    // }
  };

  submitFilter = e => {
    if (this.state.enDate && this.state.stDate == '') {
      this.showToastMsg('Please enter start date');
      return;
    }
    this.getOccupiedVacantData();
    this.getSeatOccupancyData('weekly');
    this.getSeatBookingData();
    this.getDeptBookingData();
    this.getFlexiFixedData();
    this.getShiftWiseData();
  };

  calPercentage = (value, sum) => {
    if (sum > 0) {
      let percentage = (value * 100) / sum;
      if (percentage > 0) {
        let data = percentage
          .toFixed(1)
          .toString()
          .split('.')[1];
        if (data == '0') percentage = percentage.toFixed(0) + '%';
        else percentage = percentage.toFixed(2) + '%';
      } else percentage = '';
      return percentage;
    } else return '';
  };

  render() {
    const locationOptions = [
      { value: 'all', label: 'All Locations' },
      ...(this.state.locationSpoc && this.state.locationSpoc.length > 0
        ? this.state.locationSpoc.map(item => ({
          value: item.rec_id,
          label: item.location_name,
        }))
        : []),
    ];


    const BookingInfoseat = this.state.userRole.find(
      element =>
        element.service_id == '18' &&
        (element.role_for_read === '1' || element.role_for_write === '1'),
    );
    if (!BookingInfoseat) {
      return <Navigate to="/Dashboard" />;
    }
    if (!this.state.flexiChartData) return null;
    let flexiData = this.state.flexiChartData;
    let occuData = this.state.occuChartData;
    let seatData = this.state.seatChartData;
    let locData = this.state.locationData;
    let deptData = this.state.departChartData;
    let shiftData = this.state.shiftChartData;

    let serviceAccess = true;
    const serviceAccessId = 18;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map(e => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }


    const timeOptions = [
      { value: 'weekly', label: 'Weekly' },
      { value: 'monthly', label: 'Monthly' },
    ];


    return (
      <>
        <Layout>

          <Sidebar collapsed={this.state.collapsed} />

          <CustomHeader collapsed={this.state.collapsed} toggleCollapsed={this.toggleCollapsed} />


          <Layout className={this.state.collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
            {serviceAccess === true ?
              <>
                <div className="PageContent">
                  <div className="row">

                    <div className="col-md-4">
                      <div className='SwHeading'>
                        <h2>Flexi Seat Analytics</h2>
                      </div>
                    </div>

                    <div className="col-md-8 mb-2">
                      <div className="row justify-content-end">
                        
                          <div className="col-md-3">
                            <div className="SwFormGroup">
                              <label className="SwFormLabel">Start Date</label>
                              <AntDDatePicker
                                type="single"
                                name="stDate"
                                value={this.state.stDate ? dayjs(this.state.stDate) : null}
                                allowClear={false}
                                disabledDate={(current) =>
                                  current && current > dayjs().endOf("day")
                                }
                                onChange={(date) =>
                                  this.setFilterValue({
                                    target: {
                                      name: "stDate",
                                      value: date ? date.format("YYYY-MM-DD") : "",
                                    },
                                  })
                                }
                              />

                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="SwFormGroup">
                              <label className="SwFormLabel">End Date</label>
                              <AntDDatePicker
                                type="single"
                                name="enDate"
                                value={this.state.enDate ? dayjs(this.state.enDate) : null}
                                disabled={!this.state.stDate}   // ⛔ disable until start date selected
                                allowClear={false}
                                disabledDate={(current) =>
                                  current &&
                                  (
                                    current < dayjs(this.state.stDate) || // before start date
                                    current > dayjs().endOf("day")         // after today
                                  )
                                }
                                onChange={(date) =>
                                  this.setFilterValue({
                                    target: {
                                      name: "enDate",
                                      value: date ? date.format("YYYY-MM-DD") : "",
                                    },
                                  })
                                }
                              />

                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="SwFormGroup">
                              <label className="SwFormLabel">Location</label>
                              <SwSelect
                                id="flexi-seat-location-select"
                                placeholder="Select Location"
                                options={locationOptions}
                                value={locationOptions.find(
                                  opt => opt.value === this.state.location_id
                                )}
                                isClearable={false}
                                onChange={(selectedOption) =>
                                  this.setFilterValue({
                                    target: {
                                      name: 'location_id',
                                      value: selectedOption.value,
                                    },
                                  })
                                }
                              />


                            </div>
                          </div>
                          <div className="col-md-auto">
                            <div className="SwFormGroup">
                              <label className="SwFormLabel invisible">No Label</label>
                              <SwButton
                                variant="dark"
                                size="sm"
                                onClick={this.submitFilter}
                              >
                                Search
                              </SwButton>
                            </div>
                          </div>
                        
                      </div>
                    </div>

                  </div>
                  <div className="row">
                    <div className="col-3">
                      <div className="Analytics_Card">
                        <div className="Analytics_Card_heading">Flexi vs Fixed</div>
                        <div className='chartContainer'>
                          <PieChart
                            reveal={100}
                            animate="true"
                            animationDuration={500}
                            center={[50, 50]}
                            data={flexiData}
                            labelStyle={{
                              fontSize: '8px',
                              fill: '#fff',
                            }}
                            labelPosition={65}
                            label={({ dataEntry }) =>
                              this.calPercentage(dataEntry.value, flexi_sum)
                            }
                            lengthAngle={360}
                            lineWidth={100}
                            paddingAngle={0}
                            radius={50}
                            viewBoxSize={[100, 100]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="Analytics_Card">
                        <div className="Analytics_Card_heading">Occupied vs Vacant</div>
                        <div className='chartContainer'>
                          <PieChart
                            reveal={100}
                            animate="true"
                            animationDuration={500}
                            center={[50, 50]}
                            data={occuData}
                            labelStyle={{
                              fontSize: '8px',
                              fill: '#fff',
                            }}
                            labelPosition={65}
                            label={({ dataEntry }) =>
                              this.calPercentage(dataEntry.value, occuData_sum)
                            }
                            lengthAngle={360}
                            lineWidth={100}
                            paddingAngle={0}
                            radius={50}
                            viewBoxSize={[100, 100]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="Analytics_Card">
                        <div className="Analytics_Card_heading">
                          Seat Booking Location Wise
                        </div>
                        <div className='chartContainer'>
                          <PieChart
                            reveal={100}
                            animate="true"
                            animationDuration={500}
                            center={[50, 50]}
                            data={seatData}
                            labelStyle={{
                              fontSize: '8px',
                              fill: '#fff',
                            }}
                            labelPosition={65}
                            label={({ dataEntry }) =>
                              this.calPercentage(dataEntry.value, sbl_sum)
                            }
                            lengthAngle={360}
                            lineWidth={100}
                            paddingAngle={0}
                            radius={50}
                            viewBoxSize={[100, 100]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="Analytics_Card">
                        <div className="Analytics_Card_heading">
                          Shiftwise Booking Breakup
                        </div>
                        <div className='chartContainer'>
                          <PieChart
                            reveal={100}
                            animate="true"
                            animationDuration={500}
                            center={[50, 50]}
                            data={shiftData}
                            labelStyle={{
                              fontSize: '8px',
                              fill: '#fff',
                            }}
                            labelPosition={65}
                            label={({ dataEntry }) =>
                              this.calPercentage(dataEntry.value, swd_sum)
                            }
                            lengthAngle={360}
                            lineWidth={100}
                            paddingAngle={0}
                            radius={50}
                            viewBoxSize={[100, 100]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3">
                      <div className="Analytics_Card iipannel-height">
                        <div className="Analytics_Card_heading">
                          Department Wise Booking Breakup
                        </div>
                        <div className='chartContainer'>
                          <PieChart
                            reveal={100}
                            animate="true"
                            animationDuration={500}
                            center={[50, 50]}
                            data={deptData}
                            labelStyle={{
                              fontSize: '8px',
                              fill: '#fff',
                            }}
                            labelPosition={65}
                            label={({ dataEntry }) =>
                              this.calPercentage(dataEntry.value, db_booking_sum)
                            }
                            lengthAngle={360}
                            lineWidth={100}
                            paddingAngle={0}
                            radius={50}
                            viewBoxSize={[100, 100]}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-9">
                      <div className="Analytics_Card iipannel-height">
                        <div className="chartSelect">
                          <SwSelect
                            name="time"
                            options={timeOptions}
                            value={timeOptions.find(opt => opt.value === this.state.time)}
                            onChange={(selectedOption) => {
                              this.setState({ time: selectedOption.value });
                              this.getSeatOccupancyData(selectedOption.value);
                            }}
                            isClearable={false}
                          />

                        </div>
                        <div className="Analytics_Card_heading">Seat Occupancy</div>
                        <ReactApexChart
                          className="mixed-chart"
                          options={this.state.seatOccuOptions}
                          series={this.state.seatOccuSeries}
                          type="bar"
                          height={250}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
              : this.state.loaderServiceAccess == true ? (

                <>
                  <SwLoader />
                </>

              ) : <MarketingPanel />

            }
          </Layout>

        </Layout>
      </>
    );
  }
}

export default BookingInfoseat;
